import { render } from "./PromoBranch.vue?vue&type=template&id=d4ff44be"
import script from "./PromoBranch.vue?vue&type=script&lang=js"
export * from "./PromoBranch.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__